<template>
  <div>
    <div id="CurrentSelections" class="qvobjects" style="position:relative; top:0; left:0; width:100%; height:38px;"/>
    <div class="flex-container" v-loading="isLoading" style="z-index: 5">
      <div id="QV01" class="qvobject"></div>
      <div id="QV02" class="qvobject"></div>
      <div id="QV03" class="qvobject"></div>
      <div id="QV04" class="qvobject"></div>
      <div id="QV05" class="qvobject"></div>
      <div id="QV06" class="qvplaceholder"></div>
    </div>

    <!--Error Popup-->
    <div id="popup">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closePopup"><span
        aria-hidden="true">×</span></button>
      <p id="popupText"></p>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/api'
export default {
  name: 'BIIndex',
  data () {
    return {
      isLoading: true,
      proxyUserID: `${this._uid}${(new Date()).getTime()}`,
      server: {
        protocol: 'https',
        address: 'qlik-gateway.azurewebsites.net',
        port: 443
      },
      // server: {
      //   protocol: 'https://',
      //   address: 'localhost',
      //   port: 3000
      // }
      serverAddress: '',
      proxyPath: '',
      qlikConnector: null
    }
  },
  mounted () {
    this.proxyPath = `/proxy/:${this.proxyUserID}`
    this.serverAddress = `${this.server.protocol}://${this.server.address}:${this.server.port}`
    console.log(this.serverAddress)
    this.init()
  },
  methods: {
    init () {
      api
        .post(`QlikConnector/GetSessionAuthHeader`, { user: 'aurion' })
        .then(response => {
          this.qlikConnector = response.data
          this.axios
            .post(`${this.serverAddress}/setConfig`, {
              id: this.proxyUserID,
              host: window.location.origin,
              session: `X-Qlik-Session-hdr=${this.qlikConnector.sessionID}`,
              header: this.qlikConnector.qlikHeader.split('=')
            })
            .then(_ => {
              this.loadResources()
            })
            .catch(error => {
              this.isLoading = false
              this.requestErrorHandler(error, this.L10n('general-error'))
            })
        })
        .catch(error => {
          this.isLoading = false
          this.requestErrorHandler(error, this.L10n('general-error'))
        })
    },
    loadResources () {
      console.log(`${this.serverAddress}${this.proxyPath}${this.qlikConnector.qlikCssFile}`)
      Promise.all([
        this.axios
          .get(`${this.serverAddress}${this.proxyPath}${this.qlikConnector.qlikCssFile}`)
          .then(response => {
            let css = document.createElement('style')
            css.type = 'text/css'
            if (css.styleSheet) {
              css.styleSheet.cssText = response.data
            } else {
              css.appendChild(document.createTextNode(response.data))
            }
            document.body.appendChild(css)
          }),
        this.axios
          .get(`${this.serverAddress}${this.proxyPath}${this.qlikConnector.qlikJSRequireFile}`)
          .then(response => {
            let script = document.createElement('script')
            script.type = 'text/javascript'
            script.text = response.data
            document.body.appendChild(script)
          })
      ])
        .then(_ => {
          let self_ = this
          window.require.config({
            baseUrl: `${this.serverAddress}${this.proxyPath}/hdr/resources`,
            rejectUnauthorized: false
          })
          window.require(['js/qlik'], function (qlik) {
            if (!qlik) {
              // eslint-disable-next-line
              reject('Can not require Qlik file')
            } else {
              // eslint-disable-next-line
              console.log('qlikJs init')
              // eslint-disable-next-line
              console.log(qlik)
              window.qlikJs = qlik
              self_.initApp()
            }
          })
        })
    },
    initApp () {
      let app = window.qlikJs.openApp(this.qlikConnector.qlikAppID, {
        host: this.server.address,
        prefix: `${this.proxyPath}/hdr/`,
        port: this.server.port,
        isSecure: true,
        rejectUnauthorized: false
      })
      app.on('error', error => {
        // eslint-disable-next-line
        console.error('QlikLoadService.loadApp: Error from Qlik: ', error)
        if (typeof error.method === 'string' && error.method === 'OnSessionTimedOut') {
          // eslint-disable-next-line
          console.error('logout 1')
        } else if (typeof error.message === 'string') {
          if (error.message === 'ProxyError.OnSessionTimedOut') {
            // eslint-disable-next-line
            console.error('logout 2')
          } else if (error.message === 'Forbidden' || error.message === 'Access denied') {
            // eslint-disable-next-line
            console.error(error, 'There is no data available to display for this account. Please contact your administrator')
          }
        }
      })
      app.on('warning', msg => {
        // eslint-disable-next-line
        console.warn('QlikLoadService.loadApp: Warning from Qlik: ', msg)
      })
      app.getObject('CurrentSelections', 'CurrentSelections')

      app.getObject('QV05', 'DRTvds')
      app.getObject('QV04', 'bG')

      app.getObject('QV03', 'jFTzuj')
      app.getObject('QV02', 'QMYPsk')
      app.getObject('QV01', 'hAJ')

      this.isLoading = false

      // this.qlikConnector.objectsCollection.forEach((val, i) => {
      //   app.getObject(`QV0${i + 1}`, this.qlikConnector.objectsCollection[0])
      // })
    }
  }
}
</script>

<style lang="stylus">
  .flex-container {
    display: flex;
    flex-wrap: wrap;
    margin: 0 45px 45px 0;
  }

  .qvplaceholder, .qvobject {
    flex: 1 1 auto;
    height: 300px;
    min-width: 400px;
    margin: 45px 0 0 45px;
  }

  #popup {
    background-color: #c3534b;
    color: #FFFFFF;
    position: fixed;
    max-width: 250px;
    padding: 10px;
    margin: 10px;
    bottom: 0;
    right: 0;
    display: none;
    border-radius: 5px;
    z-index: 6;
    font-family: sans-serif;
  }

  .close {
    cursor: pointer;
    background: 0 0;
    border: 0;
    float: right;
    font-size: 21px;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .2;
    position: absolute;
    right: 9px;
    top: 7px;
  }

  .close:hover {
    opacity: .5;
  }

  #popupText {
    margin-right: 23px;
  }
</style>
